import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    publicKey: String,
    orderId: String,
    customerName: String,
    customerEmail: String,
    phoneNumber: String,
    customerId: String,
    recurring: Boolean
  };

  submit(event) {
    event.preventDefault();

    const options = {
      key: this.publicKeyValue,
      order_id: this.orderIdValue,
      handler: (response) => {
        alert("Payment successful! ID: " + response.razorpay_payment_id + " Signature: " + response.razorpay_signature);
      },
      prefill: {
        name: this.customerNameValue,
        email: this.customerEmailValue,
        contact: this.phoneNumberValue
      },
      customer_id: this.customerIdValue,
      recurring: this.recurringValue,
    };

    const razorpay = new Razorpay(options);
    razorpay.open();
  }
}
